module.exports = __webpack_public_path__ + "a4ed7f78d1d62a1236430706df21a949.pdf";